import React, { useCallback, useState, ReactElement } from "react";
import { useDispatch } from "react-redux";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import axios from "axios";
import {
	twelveDataQuote,
	twelveDataTimeSeries,
} from "../../clients/twelveData";
import { company } from "./searchSymbol";

type TickerSearchOption = {
	label: string;
	instrumentName: string;
};

export default function SearchBar(): ReactElement {
	const [isLoading, setIsLoading] = useState(false);
	const [options, setOptions] = useState<TickerSearchOption[]>([]);
	const dispatch = useDispatch();

	const handleSearch = useCallback(async (query: string) => {
		setIsLoading(true);
		try {
			const res = await axios(
				`https://api.twelvedata.com/symbol_search?symbol=${query}`
			);
			const items = res.data.data;
			const labels = items.map((item: company) => ({
				label: item.symbol,
				instrumentName: item.instrument_name,
			}));
			setOptions(labels);
		} catch (error) {
			setOptions([]);
		} finally {
			setIsLoading(false);
		}
	}, []);
	const filterBy = () => true;

	const handleSelectOption = (selected: TickerSearchOption[]) => {
		const selectedTickerSymbol = selected[0]?.label;
		if (!selectedTickerSymbol) {
			return;
		}
		dispatch(twelveDataTimeSeries(undefined, selectedTickerSymbol));
		dispatch(twelveDataQuote(undefined, selectedTickerSymbol));
	};

	return (
		<>
			<AsyncTypeahead<TickerSearchOption>
				delay={800}
				filterBy={filterBy}
				highlightOnlyResult
				id="async-search"
				isLoading={isLoading}
				minLength={1}
				onSearch={handleSearch}
				onChange={handleSelectOption}
				options={options}
				placeholder="Search for Company"
				renderMenuItemChildren={(option) => (
					<span>
						{option.label}/{option.instrumentName}
					</span>
				)}
			/>
		</>
	);
}
